import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const archivedFilter = (source: ReturnType<typeof usePerformanceReviewsDataTable>) => {
  const options = [
    {
      label: i18n.t('performance_process.reviews.archive_review.hide'),
      value: false,
    },
    {
      label: i18n.t('performance_process.reviews.archive_review.show'),
      value: true,
    },
  ]

  return buildPerformanceReviewsDataTableFilter(source, {
    type: FilterType.Boolean,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'archivedFilter',
    path: 'archived',
    title: i18n.t('performance_process.reviews.archive_review.filter'),
  })
}
